import * as React from "react";

const CloseModalIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="44"
    fill="none"
    viewBox="0 0 44 44"
  >
    <rect width="44" height="44" fill="#fff" rx="22"></rect>
    <path
      stroke="#0A0A0A"
      strokeLinecap="round"
      strokeWidth="4"
      d="m15 15 14 14M15 15l14 14M15 29l14-14M15 29l14-14"
    ></path>
  </svg>
);

export default CloseModalIcon;
